import Container from '../../Container/Container'
import { useErrorPageMeta } from '../../../hooks/usePageMeta'
import { ERROR_META } from '../../../utils/pageMeta'
import MainButton from '../MainButton/MainButton'
import styles from './ErrorFallback.module.css'

interface ErrorFallbackProps {
  error?: Error
  onReset?: () => void
}

export default function ErrorFallback({ error, onReset }: ErrorFallbackProps) {
  useErrorPageMeta(ERROR_META.title, ERROR_META.description)
  const handleReload = () => {
    if (onReset) {
      onReset()
    } else {
      window.location.href = '/'
    }
  }

  return (
    <Container>
      {/* Full-page fallback: usePageMeta sets noindex + an honest title.
          Heading stays h2 so we do not invent a second document h1. */}
      <div className={styles.errorPage} role="alert" aria-live="assertive">
        <img src="/images/not-found.svg" alt="" aria-hidden="true" />
        <div className={styles.content}>
          <h2 className={styles.title}>Щось пішло не так</h2>
          <p className={styles.description}>
            Виникла несподівана помилка. Спробуй оновити сторінку або повернутися на головну
          </p>
          {process.env.NODE_ENV === 'development' && error && (
            <pre className={styles.errorDetails}>{error.message}</pre>
          )}
          <div className={styles.actions}>
            <MainButton text="На головну" href="/" />
            <button className={styles.reloadButton} onClick={handleReload}>
              Оновити сторінку
            </button>
          </div>
        </div>
      </div>
    </Container>
  )
}
